import React from 'react';
import PropTypes from 'prop-types';
import Button from '@mui/material/Button';
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';

export default function AlertBar({
  open,
  onClose,
  textContent,
  alertColor,
  autoHideDuration,
  withButton,
  anchorOrigin
}) {
  return (
    <div>
      {withButton && <Button onClick={() => onClose(false)}>Open Snackbar</Button>}
      <Snackbar
        sx={{ zIndex: 999999  }}
        open={open}
        autoHideDuration={autoHideDuration}
        onClose={onClose}
        anchorOrigin={anchorOrigin}

      >
        <Alert
          onClose={onClose}
          severity={alertColor}
          variant="filled"
          sx={{ width: '100%',borderRadius: '12px', fontSize: '16px' }}
        >
          {textContent}
        </Alert>
      </Snackbar>
    </div>
  );
}

// PropTypes for validation
AlertBar.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  textContent: PropTypes.string.isRequired,
  alertColor: PropTypes.oneOf(['error', 'warning', 'info', 'success']).isRequired,
  autoHideDuration: PropTypes.number,
  withButton: PropTypes.bool,
};

// Default props
AlertBar.defaultProps = {
  autoHideDuration: 4000,
  withButton: false,
};
